module.exports = __webpack_public_path__ + "img/vol05_cup01_label03.5e2aecf3.png";